import { useMutation } from "react-query";
import { sendRequest } from "../sendRequest";

export const connectYt = async ({ data, token }) => {
  const response = await sendRequest(
    "post",
    "/influencer/social-media-access/youtube",
    { ...data },
    {
      Authorization: `Bearer ${token}`,
    }
  );
  return response;
};

export default function useConnectYt() {
  return useMutation(connectYt);
}
